<span class="label" [ngClass]="'label--' + color">
  <ng-content></ng-content>
</span>
